<template>
    <div class="div-confirmation">
        <header-component></header-component>
        <div class="container-fluid g-py-100">
            <div v-if="!isDataLoading" class="order-confirmation row">
                <div v-if="isOrderValid" class="col-lg-8 offset-lg-2">
                    <div class="row">
                        <div v-if="$route.params.isSummaryOnly == '1' && Order.orderStatus != 'Error'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                            <h2 class="">Congratulations!</h2>
                            <p class="order-confimation-description">Your order has been submitted successfully.</p>
                            <p class="order-confimation-description">
                                Please print a copy of this for your records and include a copy along with your frame if you have placed a frame-to-come order.
                            </p>
                        </div>
                        <div v-else-if="Order.orderStatus == 'Error'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                            <p class="order-confimation-label">Error!</p>
                            <p class="order-confimation-description">This order has an error.</p>
                            <p class="order-confimation-description">
                                Kindly contact the OneSight EssilorLuxottica Foundation team for more information
                            </p>
                        </div>
                        <div v-if="isCoveredPaymentShown" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                            <p style="color:green; font-weight:bold">The voucher provided covers the payment amount for this order</p>
                        </div>
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="row mx-auto">
                                    <div class="ml-3 mr-3" v-if="Order.orderStatus.toLowerCase() == 'shipped'">
                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="MarkAsDispensed(Order.id)">Mark as Dispensed</button>
                                    </div>
                                    <div class="ml-3 mr-3" v-if="Order.orderStatus.toLowerCase() == 'dispensed'">
                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="RevertDispensed(Order.id)">Not Dispensed</button>
                                    </div>
                                    <div class="ml-3 mr-3">
                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="GenerateHtml()">Print Order Summary</button>
                                    </div>
                                    <div  v-if="Order.orderStatus != 'Error'" class="ml-3 mr-3">
                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="ReuseOrder(Order.id)">Remake/Redo Order</button>
                                    </div>
                                    <!--Need to add the new script to make this an extra pair order. If it is an extra pair, the same order will reopened and can be sent to VisionWeb but it will not have a redo treatment code-->
                                    <div  v-if="Order.orderStatus != 'Error'" class="ml-3 mr-3">
                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="ExtraPair(Order.id)">Order Extra Pair</button>
                                    </div>
                                    <div class="ml-3 mr-3">
                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10 btnDisabled" :disabled="isCancelled"
                                        @click="ToggleJotForm()"
                                        v-bind:data-balloon="GetTooltip(isCancelled)" data-balloon-pos="up">Request Cancellation</button>
                                    </div>
                                    <div class="ml-3 mr-3">
                                        <button v-if="$route.params.isSummaryOnly == '1'"class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="NewOrder()">Place New Order</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                            <div class="order-title">
                                Lab Information
                            </div>
                        </div>
                        <div v-if="Order.jobTypeDescription == 'Frame to Come'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
                            <p>
                                Please send your frame along with the lab copy of the Order Summary to this lab as soon as possible. If the frame has not been received within 2 weeks, the order will be cancelled.
                                <span style="color: red; font-weight: bold;">Please pay careful attention to the lab address. Frames shipped to the wrong lab will be drastically delayed or lost.</span>
                            </p>
                        </div>
                        <div v-else-if="Order.jobTypeDescription == 'Uncut'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
                            <p>
                                For this order, there is no need to send anything to the lab. Your uncut lens will be mailed to the address below once completed
                            </p>
                        </div>
                        <div v-else="Order.jobTypeDescription == 'Frame & Lens'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
                            <p>
                                For this order, there is no need to send anything to the lab. Keep your sample frame and the complete pair of glasses will be mailed to the address below once completed.
                            </p>
                        </div>
                        <div v-else="Order.jobTypeDescription != ''" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
                            <p>
                                If this is a frame-to-come order, please send your frame along with the lab copy of
                                the Order Summary to this lab as soon as possible. If the frame has not been received within 2 weeks, the order will be cancelled.
                            </p>
                        </div>
                        <div v-if="Order.jobTypeDescription != 'Frame to Come'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
                            <div class="row no-gutters">
                                <div v-if="Order.orderLab" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center box-div">
                                    <span>{{Order.orderLab.name}}</span></br>
                                    <span>{{Order.orderLab.shippingStreet}}</span>
                                    <span v-if="Order.jobTypeDescription == 'Frame to Come'"></br>{{"ATTN: Frame-to-Come"}}</span></br>
                                    <span>{{Order.orderLab.shippingCity}}, {{Order.orderLab.shippingStateCode}} {{Order.orderLab.shippingPostalCode}}</span></br>
                                    <span>Phone: {{"(866) 385-0447"}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="Order.jobTypeDescription == 'Frame to Come'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
                            <div  style="background-color: yellow;" class="row no-gutters">
                                <div v-if="Order.orderLab" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center box-div">
                                    <span>{{Order.orderLab.name}}</span></br>
                                    <span>{{Order.orderLab.shippingStreet}}</span>
                                    <span v-if="Order.jobTypeDescription == 'Frame to Come'"></br>{{"ATTN: Frame-to-Come"}}</span></br>
                                    <span>{{Order.orderLab.shippingCity}}, {{Order.orderLab.shippingStateCode}} {{Order.orderLab.shippingPostalCode}}</span></br>
                                    <span>Phone: {{"(866) 385-0447"}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top" >
                            <div class="order-title">
                              Participant and Order Information
                            </div>
                        </div>
                        <div class="row"
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                            <div class="form-group no-margin-bottom">
                                <label class="order-confimation-label">Participant Name:</label>
                                <span v-if="Account.accountType == 1" class="order-confimation-description">{{Account.primaryContact.firstName}} {{Account.primaryContact.lastName}} {{Account.primaryContact.suffix}}</span>
                                <span class="order-confimation-description">{{Account.primaryContact.legalName}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group no-margin-bottom">
                                <label class="order-confimation-label">Email:</label>
                                <span class="order-confimation-description">{{Account.emailAddress}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group no-margin-bottom">
                                <label class="order-confimation-label">Phone:</label>
                                <span class="order-confimation-description">{{Account.primaryContact.phoneNumber | phone_format}}</span>
                            </div>
                        </div>
                        <div class="form-group no-margin-bottom">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label class="order-confimation-label">Shipping Address:</label>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <span>{{Order.shippingFullName}}</span></br>
                                    <span>{{shippingAddressLineOne}}</span>
                                    <span v-if="shippingAddressLineTwo =null"></br>{{shippingAddressLineTwo}}</span></br>
                                    <span>{{shippingCity}}, {{shippingState}} {{shippingPostalCode}}</span></br>
                                        </br>
                                    </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group no-margin-bottom">
                                <vue-barcode :value="Order.orderNumber" :options="{ displayValue: false }"></vue-barcode>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group no-margin-bottom">
                                <label class="order-confimation-label">Patient:</label>
                                <span class="order-confimation-description">{{Order.patFirstName}} {{Order.patLastName}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <label class="order-confimation-label">E-Order #:</label>
                                <span class="order-confimation-description">{{Order.orderNumber}}</span>
                            </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group no-margin-bottom">
                                <label class="order-confimation-label">Order Reference/PO:</label>
                                <span class="order-confimation-description">{{Order.referenceNoPo}}</span>
                            </div>
                            <div class="form-group no-margin-bottom">
                                <label class="order-confimation-label">Submitted:</label>
                                <span class="order-confimation-description">{{FormatDateToLocal(Order.dateSubmitted)}}</span>
                            </div>
                        </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="order-title">
                                Lens and Prescription Information
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="order-confimation-label order-bg-blue"></th>
                                        <th class="order-confimation-label order-bg-blue">Sphere</th>
                                        <th class="order-confimation-label order-bg-blue">Cylinder</th>
                                        <th class="order-confimation-label order-bg-blue">Axis</th>
                                        <th class="order-confimation-label order-bg-blue">Addition</th>
                                        <th class="order-confimation-label order-bg-blue">Seg. Height</th>
                                        <th class="order-confimation-label order-bg-blue">Dist. PD</th>
                                        <th class="order-confimation-label order-bg-blue">Near PD</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="order-confimation-label">Right</td>
                                        <td class="order-confimation-description">{{Order.reSph}}</td>
                                        <td class="order-confimation-description">{{Order.reCyl}}</td>
                                        <td class="order-confimation-description">{{Order.reAxis}}</td>
                                        <td class="order-confimation-description">{{Order.reAdd}}</td>
                                        <td class="order-confimation-description">{{Order.reSegHeight}}</td>
                                        <td v-if="!Order.isOnly1DistancePD" class="order-confimation-description">{{Order.reDistPD}}</td>
                                        <td v-else rowspan="2" class="order-confimation-description"><p style="margin-top:20px;">{{Order.distancePD}}</p></td>
                                        <td v-if="!Order.isOnly1NearPD" class="order-confimation-description">{{Order.reNearPD}}</td>
                                        <td v-else rowspan="2" class="order-confimation-description"><p style="margin-top:20px;">{{Order.nearPD}}</p></td>
                                    </tr>
                                    <tr>
                                        <td class="order-confimation-label">Left</td>
                                        <td class="order-confimation-description">{{Order.leSph}}</td>
                                        <td class="order-confimation-description">{{Order.leCyl}}</td>
                                        <td class="order-confimation-description">{{Order.leAxis}}</td>
                                        <td class="order-confimation-description">{{Order.leAdd}}</td>
                                        <td class="order-confimation-description">{{Order.leSegHeight}}</td>
                                        <td v-if="!Order.isOnly1DistancePD" class="order-confimation-description">{{Order.leDistPD}}</td>
                                        <td v-if="!Order.isOnly1NearPD" class="order-confimation-description">{{Order.leNearPD}}</td>
                                    </tr>
                                </tbody>
                                <thead v-if="Order.IncludeAdditionalRxFields">
                                    <tr>
                                        <th class="order-confimation-label order-bg-blue"></th>
                                        <th class="order-confimation-label order-bg-blue">Horizontal Prism</th>
                                        <th class="order-confimation-label order-bg-blue">Base</th>
                                        <th class="order-confimation-label order-bg-blue">Vertical Prism</th>
                                        <th class="order-confimation-label order-bg-blue">Base</th>
                                        <th class="order-confimation-label order-bg-blue">OC Height</th>
                                        <th class="order-confimation-label order-bg-blue"></th>
                                        <th class="order-confimation-label order-bg-blue"></th>
                                    </tr>
                                </thead>
                                <tbody  v-if="Order.IncludeAdditionalRxFields">
                                    <tr>
                                        <td class="order-confimation-label">Right</td>
                                        <td class="order-confimation-description">{{Order.reHorizontalPrismValue}}</td>
                                        <td class="order-confimation-description">{{Order.reHorizontalPrismDirection}}</td>
                                        <td class="order-confimation-description">{{Order.reVerticalPrismValue}}</td>
                                        <td class="order-confimation-description">{{Order.reVerticalPrismDirection}}</td>
                                        <td class="order-confimation-description">{{Order.reocHeight}}</td>
                                        <td class="order-confimation-description"></td>
                                        <td class="order-confimation-description"></td>
                                    </tr>
                                    <tr>
                                        <td class="order-confimation-label">Left</td>
                                        <td class="order-confimation-description">{{Order.leHorizontalPrismValue}}</td>
                                        <td class="order-confimation-description">{{Order.leHorizontalPrismDirection}}</td>
                                        <td class="order-confimation-description">{{Order.leVerticalPrismValue}}</td>
                                        <td class="order-confimation-description">{{Order.leVerticalPrismDirection}}</td>
                                        <td class="order-confimation-description">{{Order.leocHeight}}</td>
                                        <td class="order-confimation-description"></td>
                                        <td class="order-confimation-description"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Lens Type</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.lensTypeDescription}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Lens Design</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.lensDesignDescription}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Order Type</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.jobTypeDescription}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Lens Material</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.lensMaterialDescription}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center div-spacing-top">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Treatment(s)</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span v-for="lt in Order.lensTreatmentDescription" class="order-confimation-description">{{lt}},</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="Order.isSpecialOrderNecessary" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center div-spacing-top">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Special Instructions</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                <span class="order-confimation-description">{{Order.specialInstructions1}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                            <div class="order-title">
                                Frame Information
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center div-spacing-top">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Manufacturer</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.frameManufacturer}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center div-spacing-top">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Frame Type</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.frameTypeDescription}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Brand</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.frameBrand}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Color</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.frameColor}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Name/Model</label>
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 border-box">
                                    <span class="order-confimation-description">{{Order.frameModel}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 center">
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Eye Size</label>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 border-box">
                                    <span class="order-confimation-description">{{Order.frameEyeSize}}</span>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 order-bg-blue border-box">
                                    <label class="order-confimation-label">Temple</label>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 border-box">
                                    <span class="order-confimation-description">{{Order.frameTempleLength}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                            <div class="order-title">
                                Patient/Order Notes
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                            <div class="row no-gutters">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 border-box min-height-dispenser-notes">
                                    <span>{{Order.dispenserNotes}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!isOrderValid" class="col-lg-8 offset-lg-2">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                            <p class="error-message">Error!</p>
                            <p class="order-confimation-description">
                                Order requested is not valid.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
    <jotform-modal v-if="isModalShown" @closeJotForm="ToggleJotForm" :Account="Account" :formID="221084120731038"></jotform-modal>
        <div v-show="markDispenseModal">
            <div class="modal-mask" role="dialog">
                <div class="overlay-mask">
                    <div class="modal-dialog">
                        <div class="modal-content g-mt-170">
                            <div class="modal-body">
                                <div class="my-account-title">Mark as Dispensed</div>
                                <div class="row g-my-20 g-mx-20 ">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15">
                                    <label>Enter Dispense Date:</label>
                                        <datepicker :disabled-picker="isDataLoading" v-model="dateDispense" :bootstrap-styling="true" :format="format" name="uniquename" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                            <button class="btn g-color-white g-bg-main g-bg-info--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15" v-on:click="SaveMarkForDispense(Order.id)">Mark Dispensed</button>
                                        <div>
                                            <small>This will mark this order as dispensed. This cannot be undone in bulk, but individual orders can be marked as Not Dispensed on the Order Confirmation page.</small>
                                        </div>

                                        <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10 g-font-size-15" v-on:click="markDispenseModal = false;">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

            <div v-if="isDataLoading" class="row margin-top">
                <page-loader></page-loader>
            </div>
        </div>
        <service-payment :Account="Account" :Order="Order" v-if="isServicePaymentShown" @close="isServicePaymentShown = false"></service-payment>
        <footer-component></footer-component>
    </div>
</template>

<script>
    import HeaderComponent from "@/components/shared/HeaderComponent";
    import FooterComponent from "@/components/shared/FooterComponent";
    import PageLoader from "@/components/shared/PageLoader";
    import MessageLoader from "@/components/shared/MessageLoader";
    import ServicePayment from "@/components/shared/ServicePayment";
    import VueBarcode from '@xkeshi/vue-barcode'
    import Datepicker from 'vuejs-datepicker';
    import JotformModal from '../../shared/JotformModal.vue';

export default {
        components: {HeaderComponent, FooterComponent, PageLoader, VueBarcode, ServicePayment, MessageLoader, Datepicker, JotformModal},
        data(){
            return{
                markDispenseModal:false,
                dateDispense:null,
                format:'MM/dd/yyyy',
                Order:{},
                Account:{},
                isDataLoading:true,
                MasterAccountType: null,
                isServicePaymentShown:false,
                isCoveredPaymentShown:false,
                isOrderValid: false,
                isModalShown: false,
                isCancelled: false,
                orderDateSubmitted: null,
                wufooStatus: 'default', // 'default', 'cancel', 'submitting'
                countDownTimer: null,
                isCancelSuccess: false,
                cancelMessage: 'Sorry, this order is no longer able to be cancelled',
                shippingAddressLineOne: '',
                shippingAddressLineTwo: '',
                shippingCity: '',
                shippingState: '',
                shippingPostalCode: ''
            }
        },
        methods: {
            RevertDispensed(id){
                // let _this = this;
                let confirmRevert = window.confirm("Are you sure you want to remove the dispensed status for this order?")
                if(confirmRevert){
                    axios.post('/Order/RevertDispensed', [{id:id, date:null}], { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' })
                    .then((response) => {
                        this.isDataLoading = false;
                        alert(`The dispensed status has been removed.`)
                        this.$router.go();
                    })
                    .catch(function(error) {
                        console.log(error);
                        alert(`An Error occurred.`)
                        this.isDataLoading = false;
                    });
                } else {

                }

            },
            MarkAsDispensed(id){
                this.markDispenseModal = true

            },
            SaveMarkForDispense(id){
                axios.post('/Order/MarkDispensed', [{id:id, date:this.dateDispense}], { headers: { 'Authorization': "Bearer " + localStorage.getItem("token") }, responseType: 'blob' })
                .then((response) => {
                    // alert(`${response.data.raw.length} records was marked dispensed.`)
                    // _this.markDispenseModal = false;
                    // _this.isDataLoading = false;
                    // _this.listToMarkDispense = []
                    alert(`Records has been marked as dispensed.`)
                    // /Portal/OrderTracking
                    // _this.$router.push({name: 'OrderTracking'});
                    this.$router.go();
                })
                .catch(function(error) {
                    console.log(error);
                    alert(`An Error occurred.`)
                    // _this.markDispenseModal = false;
                    // _this.isDataLoading = false;
                    // _this.listToMarkDispense = []
                    // _this.$router.push({name: 'Error'});
                });
            },
            GetOrderData(){
                var _this = this;
                axios.get('/Order/Get/' + this.$route.params.code, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    if (response.data.isSuccess == false){
                    _this.isDataLoading = false;
                    _this.isOrderValid = false;
                    }
                    else{
                    _this.isOrderValid = true;
                    _this.isDataLoading = false;
                    _this.Order = response.data.raw;
                    _this.shippingAddressLineOne = response.data.raw.shippingAddressLineOne;
                    _this.shippingAddressLineTwo = response.data.raw.shippingAddressLineTwo;
                    _this.shippingCity = response.data.raw.shippingCity;
                    _this.shippingState = response.data.raw.shippingState;
                    _this.shippingPostalCode = response.data.raw.shippingPostcode;

                    _this.Account = response.data.raw.accountDetails;
                    _this.Account.orderNumber = _this.Order.orderNumber;
                    if (_this.Order.jobType == 'FTC')
                    {
                        if (_this.$route.params.isSummaryOnly == '1'){
                            _this.GenerateHtml();
                        }
                    }
                    if(_this.Order.payment && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master'){
                        _this.isCoveredPaymentShown = true;
                    }else if (_this.Order.payment == false && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master'){
                        _this.isServicePaymentShown = true;
                    }
                    _this.orderDateSubmitted = _this.Order.dateSubmitted;
                    var dateDiff = _this.getDateDiff(_this.orderDateSubmitted);
                    if(dateDiff <= 172800 && _this.Order.cancellationRequestedDateTime == null && (_this.Order.orderStatus != 'Cancelled' && _this.Order.visionWebOrderStatus != 'Cancelled')) { // 172800 seconds = 48 hours
                        _this.isCancelled = false;
                    }
                    else {
                        _this.isCancelled = true;
                    }
                }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            GetAccountValues(){
                var _this = this;
                axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                    .then(function (response) {
                        _this.Account = response.data.raw;
                    })
                    .catch(function (error) {
                    console.log(error);
                    });
            },
            GetAccountBySalesForce(){
                var _this = this;
                _this.isDataLoading = true;

                axios.get('/Account/GetBySalesforceId/' + this.Order.accountId, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.isDataLoading = false;
                    _this.Account = response.data.raw;
                })
                .catch(function (error) {
                console.log(error);
                });
            },
            NewOrder(){
                this.$router.push({name: 'Order'});
            },
            ReuseOrder(id){
                // this.Order.isRemakeRedo = true;
                // this.Order.remakeRedoReason = "OTH-OPTERROR";
                this.$router.push({name: 'Order',  params: {code:id, EditOrReuse: 1}});
            },
            ExtraPair(id){
                this.$router.push({name: 'Order',  params: {code:id, EditOrReuse: 3}});
            },
            GenerateHtml(){
                var _this = this;
                var routeData = this.$router.resolve({name: 'OrderSummary', query: { orderId: _this.Order.id }});
                //window.open(routeData.href, '_top');
                window.open(routeData.href, '_blank', 'width=' + (parseInt(window.innerWidth)) + ', height=' + (parseInt(window.innerHeight)) + '');
            },
            Test() {
                alert('test');
            },
            ToggleJotForm(jotFormID){
                this.isModalShown = !this.isModalShown;
                if(this.isModalShown){
                    document.body.classList.add("body-overflow");
                }
                else{
                    document.body.classList.remove("body-overflow");
                }
            },
            CloseModal() {
                this.isModalShown = false;
                document.body.classList.remove("body-overflow");
            },
            getDateDiff(_dateSubmitted) {
                var dsUTC = new Date(_dateSubmitted); // Convert to date
                var newDsUTC = (dsUTC.getMonth() + 1) + '/' + dsUTC.getDate() + '/' + dsUTC.getFullYear() + ' ' + dsUTC.getHours() + ':' + dsUTC.getMinutes() + ':' + dsUTC.getSeconds();
                var ds = new Date(newDsUTC + ' UTC'); // Convert from UTC to local date
                var dn = new Date();
                var dateDiff = dn.getTime() - ds.getTime();
                return parseInt((dateDiff/(1000)));
            },
            CountDownWufoo() {
                var _this = this;
                _this.countDownTimer = setInterval(function(){
                    var _dateDiff = _this.getDateDiff(_this.orderDateSubmitted);
                    if(_dateDiff > 172800) { // 172,800 seconds = 48 hours
                        _this.isCancelled = true;
                        _this.wufooStatus = 'cancel';
                        clearInterval(_this.countDownTimer);
                    }
                },1000);
            },
            UpdateOrderStatus() {
                var _this = this;
                _this.wufooStatus = 'submitting';
                axios.post('/Order/UpdateCancellationData/', this.Order, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.wufooStatus = 'default';
                    _this.isCancelSuccess = true;
                    _this.isCancelled = true;
                    clearInterval(_this.countDownTimer);
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            GetTooltip(param) {
                if(!param)
                    return false;
                else
                    return this.cancelMessage;
            }
        },
        created(){
            this.MasterAccountType = localStorage.getItem("accountType");
            //this.GetAccountValues();
            this.GetOrderData();
            this.dateDispense = new Date();

        }
    }
</script>



// WEBPACK FOOTER //
// OrderConfirmation.vue?fb675436